import React, { useState, useEffect } from 'react';
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import uploadImage from '../helpers/uploadImage';
import { MdDelete } from "react-icons/md";
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

const UploadProduct = ({userType, onClose, fetchData }) => {
  const [loading, setLoading] = useState(false); 
  const [data, setData] = useState({
    productName: "",
    brandName: "",
    category: "",
    productImage: [],
    description: "",
    price: "",
    sellingPrice: 0,
    quantity: "",
    activePharmaceuticalIngredient: "",
    status: "" ,
    pic:"",
    code:"",
    toBonus: 0,
    bonusQuantity: 0
  });
  const [openFullScreenImage, setOpenFullScreenImage] = useState(false);
  const [fullScreenImage, setFullScreenImage] = useState("");
  const [isAddingNewCategory, setIsAddingNewCategory] = useState(false);
  const [productCategory, setProductCategory] = useState([]);

  const getDistinctCategories = async (userType) => {
    const response = await fetch(SummaryApi.getDistinctCategories.url, {
      method: SummaryApi.getDistinctCategories.method ,
      credentials: 'include',
      headers: {
        "Content-Type": 'application/json'
      },
      body: JSON.stringify({ userType }) // Send userType in the request body
    });
  
    const responseData = await response.json();
  
    if (responseData.success) {
      setProductCategory(responseData.data); // Assuming this sets the categories
    }
  };
  

  const handleUploadPic = async (e) => {
    const file = e.target.files[0];
    const uploadImageCloudinary = await uploadImage(file);

    setData((prev) => ({
      ...prev,
      pic :  uploadImageCloudinary.url,
    }));
  };

  const handleDeletePic = async () => {

    setData((prev) => ({
      ...prev,
      pic:"",
    }));
  };


  const handleOnChange = (e) => {
    const { name, value } = e.target;
  
    setData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === 'category' && { brandName: value }),
    }));
  };

  const handleUploadProduct = async (e) => {
    const file = e.target.files[0];
    const uploadImageCloudinary = await uploadImage(file);

    setData((prev) => ({
      ...prev,
      productImage: [...prev.productImage, uploadImageCloudinary.url],
    }));
  };

  const handleDeleteProductImage = async (index) => {
    const newProductImage = [...data.productImage];
    newProductImage.splice(index, 1);

    setData((prev) => ({
      ...prev,
      productImage: [...newProductImage],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true)
    
    if (data.sellingPrice && parseFloat(data.sellingPrice) >= parseFloat(data.price)) {
      toast.error("السعر بعد التخفيض يجب أن يكون أقل من السعر الأصلي");
      setLoading(false)
      return;
    }
    
    const requestBody = {
      ...data,
      type: userType 
    };
    
    const response = await fetch(SummaryApi.uploadProduct.url, {
      method: SummaryApi.uploadProduct.method,
      credentials: 'include',
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify(requestBody) 
    });
    
    const responseData = await response.json();

    if (responseData.success) {
      if(isAddingNewCategory){
        setLoading(false)
        toast.success(responseData?.message);
        onClose();
        fetchData();
        await fetch(SummaryApi.uploadNewBrand.url, {
          method: SummaryApi.uploadNewBrand.method,
          credentials: 'include',
          headers: {
            "content-type": "application/json"
          },
          body: JSON.stringify(requestBody) 
        });
      }
      setLoading(false)
      toast.success(responseData?.message);
      onClose();
      fetchData();
    }
    
    if (responseData.error) {
      setLoading(false)
      toast.error(responseData?.message);
    }
  };
  
  

  useEffect(() => {
    getDistinctCategories(userType);
  }, []);

  return (
    <div className='fixed w-full h-full bg-slate-200 bg-opacity-35 top-0 left-0 right-0 bottom-0 flex justify-center items-center'>
      <div className='bg-white p-4 rounded w-full max-w-2xl h-full max-h-[80%] overflow-hidden'>
        <div className='flex justify-between items-center pb-3'>
        <h2 className='font-bold text-lg text-center w-full'>
        إضافة منتج جديد
      </h2>
          <div className='w-fit ml-auto text-2xl hover:text-red-600 cursor-pointer' onClick={onClose}>
            <CgClose />
          </div>
        </div>

        <form className='grid p-4 gap-2 overflow-y-scroll h-full pb-5 text-right' onSubmit={handleSubmit}>
        <label htmlFor='productName'><span className='text-red-500 font-bold mr-1'>*</span>اسم المنتج</label>
          <input
            type='text'
            id='productName'
            placeholder='ادخل اسم المنتج'
            name='productName'
            value={data.productName}
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded text-right'
            required
          />
          <label htmlFor='code'>كود المنتج</label>
           <input
            type='text'
            id='code'
            placeholder='ادخل كود المنتج'
            name='code'
            value={data.code}
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded text-right'
          />

          <label htmlFor='activePharmaceuticalIngredient'><span className='text-red-500 font-bold mr-1'>*</span>المادة الفعالة</label>
          <input
            type='text'
            id='activePharmaceuticalIngredient'
            placeholder='ادخل المادة الفعالة'
            name='activePharmaceuticalIngredient'
            value={data.activePharmaceuticalIngredient}
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded text-right'
            required
          />

          <label htmlFor='category' className='mt-3'>اسم العلامة التجارية</label>
          {isAddingNewCategory ? (
            <>
            <input
              type='text'
              placeholder='ادخل علامة تجارية جديدة'
              value={data?.category}
              name='category'
              onChange={handleOnChange}
              className='p-2 bg-slate-100 border rounded text-right'
              required
            />
            
          <label htmlFor='categoryImage' className='mt-3'>صورة العلامة التجارية الجديدة</label>
          <label htmlFor='uploadPicInput'>
            <div className='p-2 bg-slate-100 border rounded h-32 w-full flex justify-center items-center cursor-pointer'>
              <div className='text-slate-500 flex justify-center items-center flex-col gap-2'>
                <span className='text-4xl'><FaCloudUploadAlt /></span>
                <p className='text-sm'>قم برفع صورة العلامة التجارية الجديدة</p>
                <input type='file' id='uploadPicInput' className='hidden' onChange={handleUploadPic} />
              </div>
            </div>
          </label>
          <div>
            {data?.pic ? (
              <div className='flex items-center gap-2'>
                  <div className='relative group'>
                    <img
                      src={data.pic}
                      alt="صورة العلامة التجارية الجديدة"
                      width={80}
                      height={80}
                      className='bg-slate-100 border cursor-pointer'
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(data.pic);
                      }}
                    />
                    <div
                      className='absolute bottom-0 right-0 p-1 text-white bg-red-600 rounded-full hidden group-hover:block cursor-pointer'
                      onClick={() => handleDeletePic()}
                    >
                      <MdDelete />
                    </div>
                  </div>
              </div>
            ) : (
              <p className='text-red-600 text-xs'>*من فضلك اضف صورة العلامة التجارية الجديدة</p>
            )}
          </div>
          </>
          ) : (
            <select
              required
              value={data.category}
              name='category'
              onChange={(e) => {
                if (e.target.value === "new-category") {
                  setIsAddingNewCategory(true);
                  setData({ ...data, category: "", brandName: "" });
                } else {
                  handleOnChange(e);
                }
              }}
              className='p-2 bg-slate-100 border rounded text-right'
            >
              <option value={""}>اختر العلامة التجارية</option>
              {productCategory.map((el, index) => (
                <option value={el.value} key={el.value + index}>{el.label}</option>
              ))}
              <option value="new-category">اضف علامة تجارية جديدة</option>
            </select>
          )}

          
         

          <label htmlFor='productImage' className='mt-3'>صورة المنتج</label>
          <label htmlFor='uploadImageInput'>
            <div className='p-2 bg-slate-100 border rounded h-32 w-full flex justify-center items-center cursor-pointer'>
              <div className='text-slate-500 flex justify-center items-center flex-col gap-2'>
                <span className='text-4xl'><FaCloudUploadAlt /></span>
                <p className='text-sm'>قم برفع صورة المنتج</p>
                <input type='file' id='uploadImageInput' className='hidden' onChange={handleUploadProduct} />
              </div>
            </div>
          </label>
          <div>
            {data?.productImage[0] ? (
              <div className='flex items-center gap-2'>
                {data.productImage.map((el, index) => (
                  <div className='relative group' key={index}>
                    <img
                      src={el}
                      alt={el}
                      width={80}
                      height={80}
                      className='bg-slate-100 border cursor-pointer'
                      onClick={() => {
                        setOpenFullScreenImage(true);
                        setFullScreenImage(el);
                      }}
                    />
                    <div
                      className='absolute bottom-0 right-0 p-1 text-white bg-red-600 rounded-full hidden group-hover:block cursor-pointer'
                      onClick={() => handleDeleteProductImage(index)}
                    >
                      <MdDelete />
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <p className='text-red-600 text-xs'>*من فضلك اضف صورة المنتج</p>
            )}
          </div>

          <label htmlFor='price' className='mt-3'><span className='text-red-500 font-bold mr-1'>*</span>السعر</label>
          <input
            type="number"
            id="price"
            placeholder="ادخل السعر"
            value={data.price}
            name="price"
            onChange={handleOnChange}
            className="p-2 bg-slate-100 border rounded text-right"
            min="0"
            step="0.01"
            required
          />

          <label htmlFor='quantity' className='mt-3'><span className='text-red-500 font-bold mr-1'>*</span>الكمية</label>
          <input
            type='number'
            id='quantity'
            placeholder='ادخل الكمية'
            value={data.quantity}
            name='quantity'
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded text-right'
            min={0}
            required
          />

          <label htmlFor='status' className='mt-3'><span className='text-red-500 font-bold mr-1'>*</span>حالة المنتج</label>
          <select
            id='status'
            name='status'
            value={data.status}
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded text-right'
            required
          >
            <option value={""}>اختر الحالة</option>
            <option value="Default">المنتج الافتراضي</option>
            <option value="New Arrival">منتجات حديثة الوصول</option>
            <option value="Promo Pack">العروض المجمعة</option>
            <option value="Sale">التخفيضات</option>
          </select>

          <label htmlFor='sellingPrice' className='mt-3'>السعر بعد التخفيض</label>
          <input
            type='number'
            id='sellingPrice'
            placeholder='ادخل السعر بعد التخفيض'
            value={data.sellingPrice}
            name='sellingPrice'
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded text-right'
            min={0}
            step="0.01" 
            
          />

          <label htmlFor='toBonus' className='mt-3'>الكمية المطلوبة للوصول للبونص</label>
          <input
            type='number'
            id='toBonus'
            placeholder='ادخل الكمية المطلوبة للوصول للبونص'
            value={data.toBonus}
            name='toBonus'
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded text-right'
            min={0}
            
          />

          <label htmlFor='bonusQuantity' className='mt-3'>البونص</label>
          <input
            type='number'
            id='bonusQuantity'
            placeholder='ادخل كمية البونص'
            value={data.bonusQuantity}
            name='bonusQuantity'
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded text-right'
            min={0}
            
          />

          <label htmlFor='description' className='mt-3'>شرح المنتج</label>
          <textarea
            rows={3}
            type='text'
            id='description'
            placeholder='ادخل شرح المنتج'
            value={data.description}
            name='description'
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded text-right'
          />

            <button
            type='submit'
            className={`w-full p-2 text-lg font-medium rounded ${loading ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-900 hover:bg-blue-700 active:bg-blue-700'} text-white`}
            disabled={loading}
          >
            {loading ? (
              <span className='flex justify-center items-center'>
                <AiOutlineLoading3Quarters/>
                جاري إضافة منتج جديد...
              </span>
            ) : 'إضافة منتج جديد'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default UploadProduct;
